import React from 'react';
import { InputLabel } from 'src/shared/components/ui/input-label';
import SearchInput from 'src/shared/components/search-input/SearchInput';
import SelectMultiple from 'src/shared/components/select-multiple/SelectMultiple';
import { PrimaryButton } from 'src/shared/components/button/Button';
import { UploaderType, SiteFileType } from 'src/shared/types';

type FilesFiltersProps = {
    searchText: string;
    onSearchChange: (value: string) => void;
    uploadedByFilter: Record<UploaderType, boolean>;
    onUploadedByChange: (uploaders: string[]) => void;
    fileTypeFilter?: Record<SiteFileType, boolean>;
    onFileTypeChange?: (fileTypes: string[]) => void;
    onUploadClick: () => void;
};

const FilesFilters = ({
    searchText,
    onSearchChange,
    uploadedByFilter,
    onUploadedByChange,
    fileTypeFilter,
    onFileTypeChange,
    onUploadClick,
}: FilesFiltersProps) => {
    return (
        <div className='flex gap-3 items-end w-full'>
            <SearchInput placeholder='Search files' value={searchText} onChange={e => onSearchChange(e.target.value)} width='340px' />
            {fileTypeFilter && onFileTypeChange && (
                <div className='flex flex-col ml-auto'>
                    <InputLabel className='!text-primary !text-sm'>File type</InputLabel>
                    <SelectMultiple
                        values={Object.entries(fileTypeFilter)
                            .filter(([, v]) => v)
                            .map(([k]) => k)}
                        onChange={onFileTypeChange}
                        options={[
                            { label: SiteFileType.ImageFiles, value: SiteFileType.ImageFiles },
                            { label: SiteFileType.CsvAndxlsxFiles, value: SiteFileType.CsvAndxlsxFiles },
                            { label: SiteFileType.PdfFiles, value: SiteFileType.PdfFiles },
                            { label: SiteFileType.OtherFiles, value: SiteFileType.OtherFiles },
                        ]}
                        width={220}
                        optionsWidth={220}
                        testId='file-type-select'
                        formatSelectedValues={count => `${count} selected`}
                    />
                </div>
            )}
            <div className='flex flex-col'>
                <InputLabel className='!text-primary !text-sm'>Uploaded by</InputLabel>
                <SelectMultiple
                    values={Object.entries(uploadedByFilter)
                        .filter(([, v]) => v)
                        .map(([k]) => k)}
                    onChange={onUploadedByChange}
                    options={[
                        { label: UploaderType.NatureMetrics, value: UploaderType.NatureMetrics },
                        { label: UploaderType.Client, value: UploaderType.Client },
                    ]}
                    width={220}
                    optionsWidth={220}
                    testId='uploaded-by-select'
                    formatSelectedValues={count => `${count} selected`}
                />
            </div>
            <div className='flex items-end'>
                <PrimaryButton onClick={onUploadClick} className='flex items-center gap-2'>
                    <span>Upload</span>
                    <span className='text-xl'>+</span>
                </PrimaryButton>
            </div>
        </div>
    );
};

export default FilesFilters;
